import styled from 'styled-components';

const Input = styled.input`
  display: flex;
  width: 100px;
  height: 44px;
  padding: 10px 10px 10px 14px;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
  border-radius: 2px;
  border: 1px solid #eaeaea;
`;

export default Input;
